import { Text } from "@mantine/core";

interface IChipTextProps {
  label: string | React.ReactNode;
  className?: string;
}

const ChipText: React.FC<IChipTextProps> = ({ label, className }) => {
  return (
    <div
      className={`max-w-fit grow-0 rounded-3xl bg-primary-default px-4 py-2 ${className}`}
    >
      <Text className="max-w-[610px] font-inter text-primary-white" fz={16}>
        {label}
      </Text>
    </div>
  );
};

export default ChipText;
